import _ from '../../core/utils'
import chunk from 'lodash.chunk'
import qs from 'qs'
import mapboxgl from 'mapbox-gl'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
mapboxgl.accessToken = 'pk.eyJ1IjoiYWRyaWFhbG9zIiwiYSI6ImNrNXoybGpqdTBweGszbG5qNmEwNzJ1dzAifQ.6mtLHsiBciOXdPVRMY3fuQ'
import MAP_CASE_AREA_CONFIG from "./config"
import HINT from '../hint'
import SUPERUSER from "../superuser"
import API from "../api"


class MapCaseAreaClass {
    constructor() {
        this.DOM = {
            el: MAP_CASE_AREA_CONFIG.el,
            map: null,
            show: null,
            description: null,
            edit: null,
            save: null,
            cancel: null,
            markerAdd: null,
            markerDelete: null
        }
        
        this.id = null
        this.center = null
        this.zoom = Number
        this.ico = String
        this.mapbox = null
        this.mapboxDraw = null
        this.markers = []
        this.markersCoordinates = null
        this.draw = null
        this.layer = null
        this.show = Boolean

        this.newCenter = null
        this.newLatitude = Number
        this.newLongitude = Number
        this.newZoom = Number
        this.newDraw = null
        this.newMarkersCoordinates = null

        this.editMode = false
        this.editMarkerDelete = false

        this.DOM.el ? this.init() : null
    }

    // INIT
    init() {
        this._mapSet()
        this._mapRender()
        this._controlsNavigation()
        this._controlsDraw()
        SUPERUSER ? this._superuser() : null
    }

    // MAP: set
    _mapSet() {
        // Map DOM
        this.DOM.map = _.select( '.map', this.DOM.el )
        // Case ID
        this.id = this.DOM.map.getAttribute( 'data-case-id' ) 

        // Map params
        this.center = this._centerGet()
        this.zoom = parseFloat( this.DOM.map.getAttribute( 'data-zoom' ) )
        this.ico = this.DOM.map.getAttribute( 'data-marker-ico' )
        this.draw = this._drawGet()
        this.feature = null
        this.markersCoordinates = this._markerGet()

        // Map new params
        this.newLatitude = this.latitude
        this.newLongitude = this.longitude
        this.newZoom = this.zoom
        this.newDraw = this.draw
    }
    // MAP: render
    _mapRender() {
        this.mapbox = new mapboxgl.Map({
            container: this.DOM.map,
            style: 'mapbox://styles/mapbox/light-v10',
            center: this.center[0],
            zoom: this.zoom 
        });
        
        this.mapbox.on( 'load', () => {
            this.draw != '' ? this._layerAdd( this.draw ) : null
            this.markersCoordinates != '' ? this._markerRender() : null
        })

        this._zoomDisable()
        
    }
    // MAP: on move end
    _mapOnMoveEnd() {
        this._mapGetCenter()
        this.mapbox.on( 'moveend', () => {
            this._mapGetCenter()
        })
    }
    // MAP: get new center
    _mapGetCenter() {
        let center = this.mapbox.getCenter()
        this.newCenter = `${String(center.lng)},${String(center.lat)}`
    }

    // CONTROLS
    // CONTROLS: navigation
    _controlsNavigation() {
        this.mapbox.addControl( new mapboxgl.NavigationControl() )
    }
    // CONTROLS: draw
    _controlsDraw() {
        if ( SUPERUSER ) {
            this.mapboxDraw = new MapboxDraw({
                displayControlsDefault: false,
                controls: {
                    polygon: true,
                    trash: true
                }
            })
    
            this.mapbox.addControl( this.mapboxDraw )
        }
    }

    // MARKER
    // MARKER: get
    _markerGet() {
        // Convert data-area to readable array
        let markers = '',
            markersString = this.DOM.map.getAttribute( 'data-markers' )
        if ( markersString == "" ) {
            markers = ''
        } else {
            let markersArray = markersString.split( ',')
            markers = [ _.chunk( markersArray, 2 ) ]
        }
        return markers
    }
    // MARKER: render
    _markerRender() {
        if ( this.markersCoordinates != '' ) {
            this.markersCoordinates[0].forEach( ( coords ) => {
                const marker = null
                const markerDOM = document.createElement( 'div' )
                // Create DOM marker
                markerDOM.className = 'fl__marker'
                markerDOM.innerHTML = `<span style="background-image:url(${this.ico})"></span>`
                // Create Mapbox marker
                this.marker = new mapboxgl.Marker( {
                    element: markerDOM,
                    draggable: false,
                    anchor: 'bottom'
                })
                .setLngLat( [ coords[0], coords[1] ] )
                .addTo( this.mapbox )
                // Store marker
                this.markers.push( this.marker )
                // Delete option add to marker
                this._markerDelete()
            })
        }
    }
    // MARKER: create
    _markerAdd() {
        const marker = null
        const markerDOM = document.createElement( 'div' )
        const coords = this.mapbox.getCenter()
        // Create DOM marker
        markerDOM.className = 'fl__marker'
        markerDOM.innerHTML = `<span style="background-image:url(${this.ico})"></span>`
        // Create Mapbox marker
        this.marker = new mapboxgl.Marker( {
            element: markerDOM,
            draggable: true,
            anchor: 'bottom'
        })
        .setLngLat( [ coords.lng, coords.lat ] )
        .addTo( this.mapbox )
        // Store marker
        this.markers.push( this.marker )
        // Delete option add to marker
        this._markerDelete()
    }
    // MARKER: draggable
    _markerDraggable() {
        this.markers.forEach( ( marker ) => {
            marker.setDraggable( true )
        })
    }
    // MARKER: undraggable
    _markerUndraggable() {
        //this.marker.setDraggable( false )
        this.markers.forEach( ( marker ) => {
            marker.setDraggable( false )
        })
    }
    // MARKER: set to original position
    _markerSetToOriginal() {
        this._markerDeleteAll()
        this.markers = []
        this._markerRender()
    }
    // MARKER: delete
    _markerDelete() {  
        this.markers.forEach( ( marker ) => {
            marker.on( 'dragstart', () => {
                if ( this.editMarkerDelete ) {
                    this.markers = this.markers.filter( ( e ) => {
                        return e != marker
                    })
                    marker.remove()
                }
            })
        })
    }
    // MARKER: deleteAll
    _markerDeleteAll() {
        this.markers.forEach( ( marker ) => {
            marker.remove()
        })
    }
    // MARKER: markers coordinates
    _markersCoordinates() {
        this.newMarkersCoordinates = []
        console.log( this.markers )
        this.markers.forEach( ( marker ) => {
            const coords = marker.getLngLat()
            this.newMarkersCoordinates.push( `${String(coords.lng)}` )
            this.newMarkersCoordinates.push( `${String(coords.lat)}` )
        })
        this.newMarkersCoordinates = this.newMarkersCoordinates + ""
    }

    // LAYER
    // LAYER: add
    _layerAdd( draw ) {
        this.mapbox.addSource( 'draw', {
            'type': 'geojson',
            'data': {
                'type': 'Feature',
                'geometry': {
                    'type': 'Polygon',
                    'coordinates': draw
                }
            }
        })

        this.mapbox.addLayer({
            'id': 'draw-fill',
            'type': 'fill',
            'source': 'draw',
            'layout': {},
            'paint': {
                'fill-color': '#D5DD26',
                'fill-opacity': 0.2
            }
        })

        this.mapbox.addLayer({
            'id': 'draw-outline',
            'type': 'line',
            'source': 'draw',
            'layout': {},
            'paint': {
                'line-color': '#009754',
                'line-width': 3
            }
        })
    }
    // LAYER: remove
    _layerRemove() {
        if ( this.mapbox.getLayer( 'draw-fill' ) ) {
            this.mapbox.removeLayer( 'draw-fill' )
            this.mapbox.removeLayer( 'draw-outline' )
            this.mapbox.removeSource( 'draw' )
            this._drawAdd()
            this._drawUpdate()
            this._drawCreate()
        }
    }

    // DRAW
    // DRAW: get
    _drawGet() {
        // Convert data-area to readable array
        let area = '',
            areaString = this.DOM.map.getAttribute( 'data-area' )
        if ( areaString == "" ) {
            area = ''
        } else {
            let areaArray = areaString.split( ',')
            area = [ _.chunk( areaArray, 2 ) ]
        }
        return area;
    }
    // DRAW: add
    _drawAdd() {
        this.feature = {
            id: 'unique-id',
            type: 'Feature',
            properties: {},
            geometry: { type: 'Polygon', coordinates: this.draw }
          };
        
        this.mapboxDraw.add( this.feature )
    }
    // DRAW: update
    _drawUpdate() {
        this.mapbox.on( 'draw.update', () => {
            this.newDraw = this.mapboxDraw.getAll().features[0].geometry.coordinates
        })
    }
    // DRAW: create
    _drawCreate() {
        this.mapbox.on( 'draw.create', () => {
            this.newDraw = this.mapboxDraw.getAll().features[0].geometry.coordinates
        })
    }
    // DRAW: delete
    _drawDelete() {
        this.mapbox.on( 'draw.delete', () => {
            this.newDraw = ''
        })
    }
    _drawModeChange() {
        this.mapbox.on( 'draw.modechange', ( event ) => {
           
        })
    }
    _drawActionable() {
        this.mapbox.on( 'draw.actionable', ( event ) => {
            
        })
    }
    // DRAW: delete all
    _drawDeleteAll() {
        this.mapboxDraw.deleteAll()
    }

    // ZOOM
    // ZOOM: set
    _zoomSet() {
        this.mapbox.on( 'zoomend', () => {
            this.newZoom = this.mapbox.getZoom()
        })
    }
    // ZOOM: disable
    _zoomDisable() {
        this.mapbox.scrollZoom.disable()
    }
    // ZOOM: enable
    _zoomEnable() {
        this.mapbox.scrollZoom.enable()
    }

    // CENTER
    // CENTER: get
    _centerGet() {
        // Convert center to redable array
        let center = '',
            centerString = this.DOM.map.getAttribute( 'data-center' )
        if ( centerString == "" ) {
            centerString = '26.29583630018635,49.65563818433941'
        }
        let centerArray = centerString.split( ',' ).map( Number )
        center = _.chunk( centerArray, 2 )
        return center
    }

    // EDIT
    // EDIT: check if superuser is loged
    _superuser() {
        // Map editors
        this.DOM.show = _.select( '.map__editor--map-show input', this.DOM.el )
        this._editShow()
        this.DOM.edit = _.select( '.map__editor--edit', this.DOM.el )
        this.DOM.save = _.select( '.map__editor--save', this.DOM.el )
        this.DOM.cancel = _.select( '.map__editor--cancel', this.DOM.el )
        this.DOM.markerAdd = _.select( '.map__editor--marker', this.DOM.el )
        this.DOM.markerDelete = _.select( '.map__editor--marker-delete input', this.DOM.el )

        // Listeners
        this.DOM.show.addEventListener( 'change', this._editShow.bind( this ) )
        this.DOM.edit.addEventListener( 'click', this._edit.bind( this ) )
        this.DOM.save.addEventListener( 'click', this._save.bind( this ) )
        this.DOM.cancel.addEventListener( 'click', this._cancel.bind( this ) )
        this.DOM.markerAdd.addEventListener( 'click', this._markerAdd.bind( this ) )
        this.DOM.markerDelete.addEventListener( 'change', this._editMarkerDelete.bind( this ) )
    }
    // EDIT: edit
    _edit() {
        this.editMode = true
        _.addClass( this.DOM.el, 'is--editable' )
        this.draw != '' ? this._layerRemove() : null
        this._markerDraggable()
        this._zoomSet()
        this._drawCreate()
        this._drawUpdate()
        this._drawDelete()
        this._drawModeChange()
        this._drawActionable()
        this._mapOnMoveEnd()
        this._zoomEnable()
    }
    // EDIT: map show option
    _editShow() {
        this.DOM.show.checked ? this.show = true : this.show = false
    }
    // EDIT: edit marker deleter option
    _editMarkerDelete() {
        this.editMarkerDelete = !this.editMarkerDelete
    }
    // EDIT: save edition
    _save() {
        this.editMode = false
        this._markersCoordinates()
        _.removeClass( this.DOM.el, 'is--editable' )
        API.post( 'case/edit-map/', 
            qs.stringify({
                id: this.id,
                center: this.newCenter,
                zoom: this.newZoom,
                area: this.newDraw + "",
                markers: this.newMarkersCoordinates,
                show: this.show
            })
        ).then( ( response ) => {
            if ( response.data.success ) {
                this._drawDeleteAll()
                this._layerAdd( this.newDraw )
                HINT._show( response.data.message, HINT.status.success )
            }
           
        }).catch( ( error ) => {
            console.log( error )
        }).then( () => {
            this._zoomDisable()
            HINT._hide()
        })
    }
    // EDIT: cancel edition
    _cancel() {
        this.editMode = false
        _.removeClass( this.DOM.el, 'is--editable' )
        this._drawDeleteAll()
        this.draw != '' ? this._layerAdd( this.draw ) : null
        this._markerUndraggable()
        this._markerSetToOriginal()
        this._zoomDisable()
        this.mapbox.flyTo({
            center: this.center[0],
            zoom: this.zoom,
            essential: true
        });
    }

}

const MAP_CASE_AREA = new MapCaseAreaClass()
export default MAP_CASE_AREA